import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "loader-box" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { generalStore } from "@/store/generalStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = generalStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    (_unref(store).loader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ], 64))
}
}

})